// src/pages/PrivacyPolicy.jsx
import React from 'react';
import { Container, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const PrivacyPolicy = () => (
  <Box component="main" sx={{ pt: 32 }}>
    <Container maxWidth="md">
      <Typography variant="h3" gutterBottom id="top" sx={{ scrollMarginTop: '200px' }}>
        POLITYKA PRYWATNOŚCI SERWISU BIMETRIA
        <br /><br />
      </Typography>
      <Typography paragraph>
        Niniejsza Polityka prywatności (dalej: „<strong>Polityka</strong>”) zawiera informacje na temat przetwarzania Twoich danych osobowych w związku z korzystaniem z serwisu Bimetria, działającej pod adresem internetowym Bimetria.com (dalej: „<strong>Serwis</strong>”).
      </Typography>
      <Typography variant="h4" sx={{ mt: 6, mb: 4 }}>
        Administrator danych osobowych
      </Typography>

      <Typography paragraph>
        Administratorem Twoich danych osobowych jest Bimetria spółka z ograniczoną odpowiedzialnością z siedzibą w Warszawie 
        (adres siedziby: ul. Grzybowska 87, 00-844 Warszawa), wpisana do rejestru przedsiębiorców Krajowego Rejestru Sądowego 
        prowadzonego przez Sąd Rejonowy dla m.st. Warszawy w Warszawie, XIII Wydział Gospodarczy Krajowego Rejestru Sądowego 
        pod numerem KRS: 0001217065, posiadająca NIP: 5273200143, numer REGON: 543735853, posiadająca kapitał zakładowy 
        w wysokości 5 000,00 zł (pięć tysięcy złotych) opłacony w całości , (dalej: „<strong>Administrator</strong>”).
      </Typography>
      <Typography variant="h4" sx={{ mt: 6, mb: 4 }}>
        Kontakt z Administratorem
      </Typography>
      <Typography paragraph>
        We wszystkich sprawach związanych z przetwarzaniem danych osobowych możesz
        kontaktować się z <strong>Administratorem</strong> za pomocą:
      </Typography>

      <Typography paragraph>
        a) poczty elektronicznej – pod adresem: kontakt@bimetria.com;
      </Typography>
      <Typography variant="h4" sx={{ mt: 6, mb: 4 }}>
        Środki ochrony danych osobowych
      </Typography>

      <Typography paragraph>
        Administrator stosuje nowoczesne zabezpieczenia organizacyjne i techniczne, aby zapewnić
        jak najlepszą ochronę Twoich danych osobowych oraz gwarantuje, że przetwarza je zgodnie
        z przepisami Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27
        kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych
        osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy
        95/46/WE (ogólne rozporządzenie o ochronie danych) (dalej: „<strong>RODO</strong>”), ustawy z dnia 10
        maja 2018 r. o ochronie danych osobowych oraz innymi przepisami o ochronie danych
        osobowych.
      </Typography>

      <Typography variant="h4" sx={{ mt: 6, mb: 4 }}>
        Informacje o przetwarzanych danych osobowych
      </Typography>

      <Typography paragraph>
        Korzystanie z Serwisu wymaga przetwarzania Twoich danych osobowych. Poniżej
        znajdziesz szczegółowe informacje o celach i podstawach prawnych przetwarzania, a także
        o okresie przetwarzania oraz obowiązku lub dobrowolności ich podania.
      </Typography>
      <br />
      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table sx={{ border: '1px solid #ccc' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Cel przetwarzania</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Przetwarzane dane osobowe</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Podstawa prawna</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Zawarcie i wykonanie Umowy o dostarczanie Newslettera lub innych Treści cyfrowych
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                adres e-mail
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                art. 6 ust. 1 lit. b RODO<br />
                (przetwarzanie jest niezbędne do wykonania Umowy o dostarczanie Newslettera lub Treści cyfrowych zawartej z osobą, której dotyczą dane, lub podjęcia działań w celu jej zawarcia)
                <br /><br />
                oraz<br />
                art. 6 ust. 1 lit. f RODO<br />
                (przetwarzanie jest niezbędne w celu realizacji prawnie uzasadnionego interesu Administratora, w tym przypadku informowania o nowościach i promocjach)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3} sx={{ border: '1px solid #ccc' }}>
                Podanie ww. danych osobowych jest dobrowolne, ale niezbędne w celu otrzymywania Newslettera lub Treści cyfrowych (konsekwencją ich niepodania będzie niemożność otrzymywania Newslettera lub Treści cyfrowych). Administrator będzie przetwarzał ww. dane osobowe do czasu skutecznego wniesienia sprzeciwu lub osiągnięcia celu przetwarzania albo do czasu przedawnienia roszczeń wynikających z Umowy o dostarczanie Newslettera lub Treści cyfrowych (w zależności od tego, które z wymienionych zdarzeń nastąpi wcześniej).
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>


      <br></br>
      <br></br>
      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table sx={{ border: '1px solid #ccc' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Cel przetwarzania</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Przetwarzane dane osobowe</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Podstawa prawna</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Obsługa zapytań składanych przez Użytkowników
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                1) imię i nazwisko*<br />
                2) podane przez Ciebie dane kontaktowe* (adres poczty elektronicznej; adres do korespondencji; numer telefonu)
                3) podane przez Ciebie dane zawodowe* (zawód, specjalizacja, rodzaj firmy)
                * w tym otrzymywane za pośrednictwem platformy Linkedin.com
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                art. 6 ust. 1 lit. c RODO<br />
                (przetwarzanie jest niezbędne w celu realizacji prawnie uzasadnionego interesu Administratora,
                w tym przypadku udzielenia odpowiedzi na otrzymane zapytanie)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3} sx={{ border: '1px solid #ccc' }}>
                Podanie ww. danych osobowych jest dobrowolne, ale niezbędne w celu prawidłowego wykonywania przez Administratora obowiązków wynikających z przepisów o ochronie danych osobowych, m.in. realizacji uprawnień przyznanych Ci przez RODO (konsekwencją niepodania ww. danych będzie niemożność prawidłowej realizacji ww. uprawnień). Administrator będzie przetwarzał ww. dane osobowe do czasu upływu terminów przedawnienia roszczeń z tytułu naruszenia przepisów o ochronie danych osobowych.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <br></br> <br></br>
      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table sx={{ border: '1px solid #ccc' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Cel przetwarzania</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Przetwarzane dane osobowe</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Podstawa prawna</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Wypełnienie
                obowiązków
                związanych z
                ochroną danych
                osobowych
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                1) imię i nazwisko*<br />
                2) podane przez Ciebie dane kontaktowe* (adres poczty elektronicznej; adres do korespondencji; numer telefonu)
                3) podane przez Ciebie dane zawodowe* (zawód, specjalizacja, rodzaj firmy)
                * w tym otrzymywane za pośrednictwem platformy Linkedin.com
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                art. 6 ust. 1 lit. c RODO<br />
                (przetwarzanie jest niezbędne do wypełnienia obowiązku prawnego ciążącego na Administratorze,
                w tym przypadku obowiązków wynikających z przepisów o ochronie danych osobowych)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3} sx={{ border: '1px solid #ccc' }}>
Podanie ww. danych osobowych jest dobrowolne, ale niezbędne w celu prawidłowego
wykonywania przez Administratora obowiązków wynikających z przepisów o ochronie
danych osobowych, m.in. realizacji uprawnień przyznanych Ci przez RODO
(konsekwencją niepodania ww. danych będzie niemożność prawidłowej realizacji ww.
uprawnień).
Administrator będzie przetwarzał ww. dane osobowe do czasu upływu terminów
przedawnienia roszczeń z tytułu naruszenia przepisów o ochronie danych osobowych.              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <br></br> <br></br>
      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table sx={{ border: '1px solid #ccc' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Cel przetwarzania</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Przetwarzane dane osobowe</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Podstawa prawna</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Analiza Twojej aktywności w Serwisie
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                1) data i godzina odwiedzin<br />
                2) numer IP urządzenia<br />
                3) rodzaj systemu operacyjnego urządzenia<br />
                4) przybliżona lokalizacja<br />
                5) rodzaj przeglądarki internetowej<br />
                6) czas spędzony w Serwisie<br />
                7) odwiedzone podstrony oraz inne działania podejmowane w ramach Serwisu
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                art. 6 ust. 1 lit. f RODO<br />
                (przetwarzanie jest niezbędne w celu realizacji prawnie uzasadnionego interesu Administratora,
                w tym przypadku uzyskania informacji o Twojej aktywności w Serwisie)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3} sx={{ border: '1px solid #ccc' }}>
                Podanie ww. danych osobowych jest dobrowolne, ale niezbędne w celu uzyskania przez Administratora informacji o Twojej aktywności w Serwisie (konsekwencją ich niepodania będzie niemożność uzyskania przez Administratora ww. informacji). Administrator będzie przetwarzał ww. dane osobowe do czasu skutecznego wniesienia sprzeciwu lub osiągnięcia celu przetwarzania.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
            <br></br> <br></br>
             <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table sx={{ border: '1px solid #ccc' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Cel przetwarzania</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Przetwarzane dane osobowe</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>Podstawa prawna</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Administrowanie Serwisem
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                1) adres IP<br />
                2) data i czas serwera<br />
                3) informacje o przeglądarce internetowej<br />
                4) informacje o systemie operacyjnym<br /><br />
                Powyższe dane te są zapisywane automatycznie w tzw. logach serwera,
                przy każdorazowym korzystaniu z Serwisu (administrowanie nim bez użycia logów serwera i automatycznego zapisu nie byłoby możliwe).
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                art. 6 ust. 1 lit. f RODO<br />
                (przetwarzanie jest niezbędne w celu realizacji prawnie uzasadnionego interesu Administratora,
                w tym przypadku zapewnienia prawidłowego działania Serwisu)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3} sx={{ border: '1px solid #ccc' }}>
                Podanie ww. danych osobowych jest dobrowolne, ale niezbędne w celu zapewnienia prawidłowego działania Serwisu (konsekwencją ich niepodania będzie niemożność zapewnienia działania Serwisu w sposób prawidłowy). Administrator będzie przetwarzał ww. dane osobowe do czasu skutecznego wniesienia sprzeciwu lub osiągnięcia celu przetwarzania.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
        <Typography variant="h3" sx={{ mt: 6, mb: 4 }}>
        Odbiorcy danych osobowych
      </Typography>

      <Typography paragraph>
        Odbiorcami danych osobowych będą następujące podmioty zewnętrzne współpracujące z Administratorem:
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        a) firma hostingowa;<br />
        b) dostawcy systemów płatności online;<br />
        c) dostawca usługi newslettera;<br />
        d) firmy dostarczające narzędzia służące do analizy aktywności w Serwisie i kierowania marketingu bezpośredniego do osób z niego korzystających (m.in. Google Analytics);<br />
        e) firma świadcząca usługi księgowe;<br />
        f) kancelarie prawne wspierające Administratora.
      </Typography>

      <Typography paragraph>
        Ponadto, dane osobowe mogą zostać przekazane również podmiotom publicznym lub prywatnym,
        jeśli taki obowiązek będzie wynikał z powszechnie obowiązujących przepisów prawa,
        prawomocnego wyroku sądu lub prawomocnej decyzji administracyjnej.
      </Typography>
<Typography variant="h3" sx={{ mt: 6, mb: 4 }}>
        Przekazywanie danych osobowych do państwa trzeciego
      </Typography>

      <Typography paragraph>
        W związku z korzystaniem przez Administratora z usług dostarczanych przez Google LLC
        Twoje dane osobowe mogą być przekazywane do następujących państw trzecich: Wielka
        Brytania, Kanada, USA, Chile, Brazylia, Izrael, Arabia Saudyjska, Katar, Indie, Chiny, Korea
        Południowa, Japonia, Singapur, Tajwan (Republika Chińska), Indonezja oraz Australia.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        – w przypadku Wielkiej Brytanii, Kanady, Izraela i Japonii — decyzje Komisji Europejskiej
        stwierdzające odpowiedni stopień ochrony danych osobowych w każdym z ww. państw trzecich;
        <br />
        – w przypadku USA, Chile, Brazylii, Arabii Saudyjskiej, Kataru, Indii, Chin, Korei
        Południowej, Singapuru, Tajwanu (Republiki Chińskiej), Indonezji oraz Australii — klauzule
        umowne zapewniające odpowiedni poziom ochrony, zgodne ze standardowymi klauzulami
        umownymi określonymi w decyzji wykonawczej Komisji (UE) 2021/914 z dnia 4 czerwca 2021 r.
        w sprawie standardowych klauzul umownych dotyczących przekazywania danych osobowych
        do państw trzecich na podstawie rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679.
      </Typography>

      <Typography paragraph>
        Możesz uzyskać od Administratora kopię danych przekazywanych do państwa trzeciego.
      </Typography>

        <Typography variant="h3" sx={{ mt: 6, mb: 4 }}>
        Uprawnienia
      </Typography>

      <Typography paragraph>
        W związku z przetwarzaniem danych osobowych, przysługują Ci następujące uprawnienia:
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        1) prawo do informacji, jakie dane osobowe Ciebie dotyczące są przetwarzane przez
        Administratora oraz do otrzymania kopii tych danych (tzw. prawo dostępu). Wydanie
        pierwszej kopii danych jest darmowe, za kolejne Administrator może naliczyć opłatę;
        <br /><br />
        2) jeżeli przetwarzane dane staną się nieaktualne lub niekompletne (lub w inny sposób
        niepoprawne) masz prawo zażądać ich sprostowania;
        <br /><br />
        3) w pewnych sytuacjach możesz zwrócić się do Administratora o usunięcie swoich
        danych osobowych, np. gdy:
        <br />
        <span style={{ display: 'block', marginLeft: '1em' }}>
          a) dane przestaną być potrzebne Administratorowi do celów, o których poinformował;<br />
          b) skutecznie cofnąłeś zgodę na przetwarzanie danych — o ile Administrator nie
          ma prawa przetwarzać danych na innej podstawie prawnej;<br />
          c) przetwarzanie jest niezgodne z prawem;<br />
          d) konieczność usunięcia danych wynika z ciążącego na Administratorze
          obowiązku prawnego;
        </span>
        <br /><br />
        4) w przypadku, gdy dane osobowe są przetwarzane przez Administratora na podstawie udzielonej zgody
        na przetwarzanie albo w celu wykonania Umowy z nim zawartej, masz prawo przenieść swoje dane do innego administratora;
        <br /><br />
        5) w przypadku, gdy dane osobowe przetwarzane są przez Administratora na
        podstawie udzielonej przez Ciebie zgody na przetwarzanie, masz prawo cofnąć tę
        zgodę w każdym momencie (cofnięcie zgody nie wpływa na zgodność z prawem
        przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem);
        <br /><br />
        6) jeśli uznasz, że przetwarzane dane osobowe są nieprawidłowe, ich przetwarzanie
        jest niezgodne z prawem, lub Administrator nie potrzebuje już określonych danych,
        możesz zażądać, aby przez określony, potrzebny czas (np. sprawdzenia
        poprawności danych lub dochodzenia roszczeń) Administrator nie dokonywał na
        danych żadnych operacji, a jedynie je przechowywał;
        <br /><br />
        7) masz prawo do wyrażenia sprzeciwu wobec przetwarzania danych osobowych,
        których podstawą przetwarzania jest prawnie uzasadniony interes Administratora.
        W razie skutecznego wniesienia sprzeciwu, Administrator przestanie przetwarzać dane
        osobowe w ww. celu;
        <br /><br />
        8) masz prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych, gdy
        uznasz, że przetwarzanie danych osobowych narusza przepisy RODO.
      </Typography>


      <Typography variant="h3" sx={{ mt: 6, mb: 4 }}>
        Pliki cookies
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        1. Administrator informuje, że Serwis korzysta z plików „cookies” (ciasteczka),
        instalowanych w Twoim urządzeniu końcowym. Są to niewielkie pliki tekstowe, które
        mogą być one odczytywane przez system Administratora, a także przez systemy
        należące do innych podmiotów, z których usług korzysta Administrator (np. Facebooka,
        Google’a).
        <br /><br />
        2. Administrator wykorzystuje pliki cookies w następujących celach:
        <br />
        <span style={{ display: 'block', marginLeft: '1em' }}>
          a) zapewnienie prawidłowego działania Serwisu – dzięki plikom cookies, możliwe
          jest sprawne działanie Serwisu, korzystanie z jego funkcji oraz wygodne
          przemieszczanie się między poszczególnymi podstronami;<br />
          b) zwiększenie komfortu korzystania z Serwisu – dzięki plikom cookies możliwe jest
          wykrywanie błędów na niektórych podstronach oraz ich stałe ulepszanie;<br />
          c) tworzenie statystyk – pliki cookies są wykorzystywane w celu dokonania analizy
          sposobu korzystania przez użytkowników Serwisu. Dzięki temu możliwe jest stałe
          ulepszanie Serwisu i dostosowywanie jej działania do preferencji użytkowników;<br />
          d) prowadzenia działań marketingowych – dzięki plikom cookies, Administrator może
          kierować do użytkowników reklamy dostosowane do ich preferencji.
        </span>
        <br /><br />
        3. Administrator może umieszczać w Twoim urządzeniu zarówno pliki trwałe, jak i
        tymczasowe (sesyjne). Pliki sesyjne są zazwyczaj usuwane z chwilą zamknięcia
        przeglądarki, natomiast zamknięcie przeglądarki nie powoduje usunięcia plików trwałych.
        <br /><br />
        4. Informacja o plikach cookies wykorzystywanych przez Administratora wyświetlana jest w
        panelu znajdującym się w dolnej części strony internetowej/stopce Serwisu. W zależności
        od Twojej decyzji, możesz włączyć lub wyłączyć pliki cookies poszczególnych kategorii (z
        wyjątkiem niezbędnych plików cookies) oraz zmieniać te ustawienia w każdym czasie.
        <br /><br />
        5. Dane zbierane za pomocą plików cookies nie pozwalają Administratorowi na Twoją
        identyfikację.
        <br /><br />
        6. Administrator korzysta z następujących plików cookies lub wykorzystujących je narzędzi:
      </Typography>
      <br></br><br></br>
        <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table sx={{ border: '1px solid #ccc' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>NARZĘDZIE</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>DOSTAWCA</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>FUNKCJE I ZAKRES POBIERANYCH DANYCH</strong>
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                <strong>OKRES DZIAŁANIA</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Niezbędne pliki cookies
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Administrator
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Działanie tych plików jest niezbędne do prawidłowego funkcjonowania strony
                internetowej, dlatego nie możesz ich wyłączyć. Dzięki tym plikom (pobierających
                m.in. numer IP Twojego urządzenia), możliwe jest m.in. informowanie Cię o
                plikach cookies działających w Serwisie.
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Większość niezbędnych plików cookies ma charakter sesyjny, niektóre jednak
                pozostają w Twoim urządzeniu końcowym przez okres 12 miesięcy lub do
                momentu ich usunięcia.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Google Analytics
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Google
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                Narzędzie to umożliwia zbieranie danych statystycznych o sposobie korzystania
                z Serwisu przez Użytkowników, m.in. o liczbie odwiedzin, czasie trwania odwiedzin,
                stosowanej wyszukiwarce, lokalizacji. Zebrane dane pomagają ulepszać Serwis
                oraz czynić go bardziej przyjaznym dla Użytkowników.
              </TableCell>
              <TableCell sx={{ border: '1px solid #ccc' }}>
                do 2 lat lub do momentu ich usunięcia (w zależności od tego, które z wymienionych
                zdarzeń nastąpi wcześniej)
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <br></br><br></br>
          <Typography paragraph sx={{ pl: 2 }}>
        7. Za pośrednictwem większości powszechnie używanych przeglądarek możesz sprawdzić,
        czy na Twoim urządzeniu końcowym zostały zainstalowane pliki cookies, jak również
        usunąć zainstalowane pliki cookies oraz zablokować instalowanie ich w przyszłości przez
        Serwis. Wyłączenie lub ograniczenie obsługi plików cookies może jednak spowodować
        dość poważne trudności w korzystaniu z Serwisu, np. w postaci konieczności logowania
        się na każdej podstronie, dłuższego okresu ładowania się Serwisu, ograniczeń w
        korzystaniu z niektórych funkcjonalności.
      </Typography>
         <Typography variant="h3" sx={{ mt: 6, mb: 4 }}>
        Postanowienia końcowe
      </Typography>

      <Typography paragraph>
        W zakresie nieuregulowanym Polityką, stosuje się powszechnie obowiązujące przepisy o
        ochronie danych osobowych.
        <br /><br />
        Polityka obowiązuje od dnia 16.02.2025 r.
      </Typography>
    </Container>
  </Box>
);

export default PrivacyPolicy;
